import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { isMobile, currencyValue } from "utils/common";
import toast_error from "svg/toast_error.svg";
import Button from "react-bootstrap/Button";
import Modal from "common/modal";
import quote from "svg/quote.svg";
import "./style.scss";

const Confirmation = ({
  confirmPrcUpdate,
  productsData,
  quoteFields,
  setStage,
  prcType,
  prcDesc,
  quotePriceCalculation,
  successModal,
  setSuccessModal,
  prcDets,
}) => {
  const { quoteId } = useParams();
  const navigate = useNavigate();
  const [mobileView, setMobileView] = useState(false);
  const [confirmationData, setConfirmationData] = useState();
  const [isShowConfirmModal, setIsShowConfirmModal] = useState(false);
  const [alertNotification, setAlertNotification] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      if (!isMobile()) {
        setMobileView(false);
      } else {
        setMobileView(true);
      }
    };
    window.addEventListener("resize", handleResize);
    if (isMobile()) {
      handleResize();
    }
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [mobileView]);

  const handlePrcPage = () => {
    setStage("prc");
  };

  useEffect(() => {
    const tempProducts = [];
    productsData.map((ele) => {
      if (ele.isProductSelected && !ele.isProductDisabled) {
        tempProducts.push(ele);
      }
    });
    setConfirmationData(tempProducts);
  }, [productsData]);

  useEffect(() => {
    confirmationData?.some((prod) => {
      if (prod.price < prod.prcPrice) {
        setAlertNotification(true);
      }
      return prod.price < prod.prcPrice;
    });
  }, [confirmationData]);

  const handlePRCUpdate = () => {
    setIsShowConfirmModal(true);
  };

  const handleSave = () => {
    confirmPrcUpdate();
    setIsShowConfirmModal(false);
  };

  const handleCancel = () => {
    setIsShowConfirmModal(false);
    if (successModal) {
      setSuccessModal(false);
      navigate(`/priceQuote/${quoteId}#quote-summary`);
    }
  };

  return (
    <>
      <div className="container-fluid search-form-container">
        <div className="search-form-container__title">
          <span className="search-form-container__title--text">
            <img src={quote} alt="quote" />
            &nbsp;Confirmation
          </span>
        </div>

        <div className="d-md-flex flex-column flex-md-row mt-md-5 mb-5 overflow-auto position-relative spacing">
          <div className="d-flex flex-row flex-md-column info-item justify-content-between justify-content-md-start col-12 col-md-3">
            <div className="info-item__label">Account</div>
            <div className="info-item__value text-end text-md-start">
              {!quoteFields.accountNumber ? "N/A" : `${quoteFields.accountNumber} - ${quoteFields.accountName}`}
            </div>
          </div>
          <div className="d-flex flex-row flex-md-column info-item justify-content-between justify-content-md-start col-12 col-md-3">
            <div className="info-item__label">Job</div>
            <div className="info-item__value text-end text-md-start">
              {!quoteFields.jobNumber ? "N/A" : `${quoteFields.jobNumber} : ${quoteFields.jobName}`}
            </div>
          </div>
          <div className="d-flex flex-row flex-md-column info-item justify-content-between justify-content-md-start col-12 col-md-3">
            <div className="info-item__label">PRC</div>
            <div className="info-item__value text-end text-md-start">
              {prcType === "create"
                ? `New PRC : ${prcDesc}`
                : !quoteFields.prcNumber
                  ? "N/A"
                  : `${quoteFields.prcNumber} : ${quoteFields.prcDesc}`}
            </div>
          </div>
        </div>

        {alertNotification && (
          <div className="alert-msg alert-danger d-flex align-items-center" role="alert">
            <img src={toast_error} />
            &nbsp;<div>District leadership will be notified of all price decreases.</div>
          </div>
        )}

        <div className="prod-header con-sizing">Material Items</div>
        {confirmationData?.map((data, index) => {
          return (
            <div className="bulkUpdateQuote_container" key={index + data.productName}>
              <div className="row bulkUpdateQuote_container__floor_area">
                <div className="d-md-flex flex-column flex-md-row overflow-auto position-relative">
                  <div
                    className={`d-flex flex-row flex-md-column info-item justify-content-between justify-content-md-start ${
                      !mobileView ? "sales-width" : ""
                    }`}
                  >
                    <div className="info-item__label">Sales Number</div>
                    <div className="info-item__value text-end text-md-start">
                      {!data.salesNumber ? "N/A" : data.salesNumber}
                    </div>
                  </div>
                  <div
                    className={`d-flex flex-row flex-md-column info-item justify-content-between justify-content-md-start ${
                      !mobileView ? "prod-width" : ""
                    }`}
                  >
                    <div className="info-item__label">Product Name</div>
                    <div className="info-item__value text-end text-md-start prod-name">{data.productName}</div>
                  </div>
                  <div
                    className={`d-flex flex-row flex-md-column info-item justify-content-between justify-content-md-start ${
                      !mobileView ? "category-width" : ""
                    }`}
                  >
                    <div className="info-item__label">Category</div>
                    <div className="info-item__value text-end text-md-start">{data.category}</div>
                  </div>
                  <div
                    className={`d-flex flex-row flex-md-column info-item justify-content-between justify-content-md-start ${
                      !mobileView ? "prc-width" : ""
                    }`}
                  >
                    <div className="info-item__label text-md-end">Old Price</div>
                    <div className="info-item__value text-end text-md-end">{currencyValue(data.prcPrice)} </div>
                  </div>
                  <div
                    className={`d-flex flex-row flex-md-column info-item justify-content-between justify-content-md-start ${
                      !mobileView ? "price-width" : ""
                    }`}
                  >
                    <div className="info-item__label text-md-end">New Price</div>
                    <div className="info-item__value text-end text-md-end">{currencyValue(data.price)}</div>
                  </div>
                  <div
                    className={`d-flex flex-row flex-md-column info-item justify-content-between ${
                      !mobileView ? "dot-width confir" : ""
                    }`}
                  >
                    <div></div>
                    <div className="info-item__value text-start text-md-start">
                      {currencyValue(data.price) !== currencyValue(data.prcPrice) && (
                        <div className={`dotstyle ${quotePriceCalculation(data.price, data.prcPrice)}`}>&#11044;</div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          );
        })}

        <div className="d-flex justify-content-between flex-column flex-md-row mt-10 footer-spacing">
          <Button variant="outline-primary" onClick={handlePrcPage}>
            Back
          </Button>
          <Button variant="primary" onClick={handlePRCUpdate}>
            {prcType === "update" ? "Update PRC" : "Create PRC"}
          </Button>
        </div>
      </div>

      {isShowConfirmModal && (
        <Modal
          title={"Confirmation"}
          saveButtonText={"Confirm"}
          closeButtonText={"Cancel"}
          handleSave={handleSave}
          handleCancel={handleCancel}
          size={mobileView ? "sm" : "lg"}
        >
          <p className="confirmation-text">
            {prcType === "update" ? "Are you sure you want to update PRC?" : "Are you sure you want to create new PRC?"}
          </p>
        </Modal>
      )}

      {successModal && (
        <Modal title={"Success!"} closeButtonText={"Ok"} handleCancel={handleCancel} size={mobileView ? "sm" : "lg"}>
          <p className="confirmation-text">
            {prcType === "update"
              ? `You have updated Job ${quoteFields.jobNumber} : ${quoteFields.jobName} and PRC ${quoteFields.prcNumber} : ${quoteFields.prcDesc}`
              : `You have created PRC ${prcDets?.prcNumber} : ${prcDets?.prcDesc} for Job ${quoteFields.jobNumber} : ${quoteFields.jobName}.`}
            <br />
            {prcDesc?.toLowerCase() != prcDets?.prcDesc?.toLowerCase() && (
              <p className="py-3">
                The description was changed to Main Account because this is required on the first PRC for an account.
              </p>
            )}
          </p>
        </Modal>
      )}
    </>
  );
};

export default Confirmation;
